import React, { useMemo } from 'react';

import { BuilderComponent } from '@builder.io/react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { trackBuilderTest } from '../../utils/builderTesting';
import { useBuilderContent } from '../../utils/useBuilderContent';
import useBuilderJson from '../../utils/useBuilderJson';

const pdpVideoCarouselBuilderModelName = 'pdp-video-carousel';
const pdpVideoThumbnailsCarouselBuilderModelName =
  'pdp-video-thumbnails-carousel';

function PDPVideoCarousel({
  product,
  builderQueries,
  isThumbnailsMode = false,
}) {
  const dispatch = useDispatch();
  const groupCode = product?.groupCode;
  const builderModelName = isThumbnailsMode
    ? pdpVideoThumbnailsCarouselBuilderModelName
    : pdpVideoCarouselBuilderModelName;
  const builderProperties = useMemo(
    () => ({
      modelName: builderModelName,
      query: {
        data: {
          storeGroupCode: {
            $in: [{ storeGroupCode: groupCode }, `${groupCode}`],
          },
        },
      },
      builderQueries,
    }),
    [groupCode, builderQueries, builderModelName]
  );
  const { builderJson } = useBuilderJson(builderProperties);
  const { content, locale } = useBuilderContent(builderJson);

  return (
    <BuilderComponent
      options={{
        enrich: true,
      }}
      model={builderModelName}
      content={content}
      context={{ isOnPDP: true, isThumbnailsMode, subTitle: product?.label }}
      locale={locale}
      contentLoaded={(data, content) => {
        trackBuilderTest(dispatch, content);
      }}
    />
  );
}

PDPVideoCarousel.propTypes = {
  builderQueries: PropTypes.object,
  isThumbnailsMode: PropTypes.bool,
  product: PropTypes.object,
};

export default PDPVideoCarousel;
